import { render, staticRenderFns } from "./practiceTest.vue?vue&type=template&id=05e78d1a&scoped=true&"
import script from "./practiceTest.vue?vue&type=script&lang=js&"
export * from "./practiceTest.vue?vue&type=script&lang=js&"
import style0 from "./practiceTest.vue?vue&type=style&index=0&id=05e78d1a&scoped=true&lang=scss&"
import style1 from "./practiceTest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e78d1a",
  null
  
)

export default component.exports